"use client";

import CardGrid from "@/components/card-grid/card-grid";
import FilterBar from "@/components/filter-bar/filter-bar";
import { getGenreGrid } from "@/lib/api/genre/grid";
import { useEffect, useState } from "react";
import useSWR from "swr";
import Loading from "../_partials/loading/loading";
import { Sort } from "../_types/sort";

const GenreGrid = ({
	kindObj,
	initialSorts,
	initialData,
	initialSearchTerm,
	initialPage,
	initialSort,
	title,
}: {
	kindObj: any;
	initialSorts: any[];
	initialData: any;
	initialSearchTerm?: string;
	initialPage?: string;
	initialSort?: Sort;
	title?: string;
}) => {
	const [selectedSort, setSelectedSort] = useState(initialSort ?? undefined);
	const [searchTerm, setSearchTerm] = useState(initialSearchTerm || "");
	const [page, setPage] = useState(initialPage ?? "1");

	let genre;

	const {
		data: data,
		mutate,
		isLoading,
	} = useSWR(
		[
			"genre-grid",
			kindObj.kind,
			title ?? "",
			searchTerm,
			selectedSort?.value,
			page,
		],
		() =>
			getGenreGrid(kindObj.kind, title ?? "", searchTerm, selectedSort, page),
		{
			fallbackData: initialData,
			revalidateOnMount: false,
		}
	);

	useEffect(() => {
		const query = new URLSearchParams();

		searchTerm && query.append("title", searchTerm);
		page && query.append("page", page);
		if (selectedSort) {
			query.append("sortBy", selectedSort.sortBy);
			query.append("direction", selectedSort.direction);
		}

		const qs = query.toString();
		const newUrl = qs
			? `${window.location.pathname}?${qs}`
			: window.location.pathname;

		window.history.replaceState(null, "", newUrl);
	}, [searchTerm, selectedSort, page, mutate]);

	const isFetching = isLoading;

	if (
		data.content &&
		data.content?.length > 0 &&
		data.content[0]?.genres &&
		data.content[0]?.genres.length > 0
	) {
		genre = data.content[0].genres.find((cat: any) => cat.id === title);
	}

	return (
		<>
			<div className="w-full flex flex-wrap justify-between items-center px-6 py-4 gap-4">
				<h2 className="text-white text-[32px] font-bold">
					{genre?.persianName ?? kindObj?.persianName}
				</h2>
				<FilterBar
					showSearch={true}
					showSort={true}
					showGenre={false}
					searchTerm={searchTerm}
					setSearchTerm={setSearchTerm}
					initialSorts={initialSorts}
					setSort={setSelectedSort}
				/>
			</div>
			{isFetching ? (
				<div className="w-full h-full min-h-screen flex justify-center items-center">
					<Loading />
				</div>
			) : (
				<CardGrid
					data={data}
					kind={kindObj?.kind}
					activeGenre={genre}
					page={page}
					setPage={setPage}
				/>
			)}
		</>
	);
};

export default GenreGrid;
